"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stylize = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var merge_style_1 = require("../../_util/merge-style");
function stylize(_a) {
    var className = _a.className, style = _a.style, headClassName = _a.headClassName, headStyle = _a.headStyle, bodyClassName = _a.bodyClassName, bodyStyle = _a.bodyStyle;
    var addon = { getInfo: function () { return ({ name: "stylize" }); } };
    if (className || style) {
        addon.onInjectTable = withStyle(className, style);
    }
    if (headClassName || headStyle) {
        addon.onInjectHead = withStyle(headClassName, headStyle);
    }
    if (bodyClassName || bodyStyle) {
        addon.onInjectBody = withStyle(bodyClassName, bodyStyle);
    }
    return addon;
}
exports.stylize = stylize;
function withStyle(className, style) {
    return function (render) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var element = render.apply(void 0, tslib_1.__spread(args));
        var elementProps = element.props;
        return react_1.default.cloneElement(element, {
            className: classnames_1.default(elementProps.className, className),
            style: merge_style_1.mergeStyle(elementProps.style, style),
        });
    }; };
}
//# sourceMappingURL=stylize.js.map